import customFetchBase from "../../../principal/customFetchBase";
import {createApi} from "@reduxjs/toolkit/query/react";

export const cursosApi = createApi({
  reducerPath: "cursosApi",
  baseQuery: customFetchBase,
  tagTypes: ["Cursos", "Modalidades"],
  endpoints: () => ({}),
});